// extracted by mini-css-extract-plugin
export default {"container":"combined-spiand-specialties_container__gNQhq"};